import React from "react";

import Doctor from "./../../../assets/images/Icons/Doctor.svg";
import Photograph from "./../../../assets/images/Icons/Links/Photograph.svg";
import Play from "./../../../assets/images/Icons/Links/Play.svg";

//Style
import { MDBRow, MDBCol, MDBCard, MDBCardBody } from "mdbreact";
import "./Share.scss";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

const Share = (props: {}) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <MDBRow className="share mt-1">
      <MDBCol>
        <MDBCard>
          <MDBCardBody>
            <section>
              <img src={Doctor} alt="Doctor" />
              <h6 className="mr-2 float-right">{state?.addPostPlaceholder}</h6>
              <div className="float-left m-auto icon">
                <img src={Photograph} className="d-inline-inline ml-2" />{" "}
                <img src={Play} className="d-inline-inline" />{" "}
              </div>
            </section>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>
  );
};

export default Share;
